import React, { FC, useEffect, useRef } from 'react';
import './presenter-slide-description.scss';
import { ReactComponent as PrevArrowIcon } from '../../../assets/icons/prev-arrow.svg';
import { ReactComponent as NextArrowIcon } from '../../../assets/icons/next-arrow.svg';
import { ISubSlideCarouselComponentsProps } from '../presenter-slide-carousel/presenter-slide-carousel';
import { observer } from 'mobx-react';
import FullscreenIcon from '../../../assets/icons/slides-fullscreen-button.svg';
import TransparentButton from '../../shared/transparent-button/transparent-button';
import { useStore } from '../../../store/store-provider';
import { DESKTOP_BREAKPOINT } from '../../../constans/responsive-break-points';

const PresenterSlideDescription: FC<ISubSlideCarouselComponentsProps> = ({
  currentSlide,
  numberOfSlides,
  currentSlideIndex,
  onPrevSlideHandler,
  onNextSlideHandler,
  prevArrowDisabledClass,
  nextArrowDisabledClass,
  onFullscreenHandler
}): JSX.Element => {
  const { podiumInfoStore } = useStore();
  const { isResolutionBreakPointActive } = podiumInfoStore;
  const isMobile = isResolutionBreakPointActive(DESKTOP_BREAKPOINT);

  const descriptionBoxRef = useRef<HTMLDivElement>(null);
  const descriptionBoxCurrent = descriptionBoxRef.current!;
  const additionalIndex = 1;
  const arrowsClasses = {
    prev: 'presenter-slide-description__arrow presenter-slide-description__arrow_prev',
    next: 'presenter-slide-description__arrow presenter-slide-description__arrow_next '
  };

  const scrollToTop = () => {
    descriptionBoxCurrent.scrollTo(0, 0);
  };

  useEffect(() => {
    if(!(currentSlide?.speakerNotes && descriptionBoxCurrent)) return;
    scrollToTop();
  }, [currentSlide]);

  return (
    <div className="presenter-slide-description">
      <div className=" presenter-slide-description__title-content">
        <div className="presenter-slide-description__title-wrapper">
          {!isMobile && (
            <TransparentButton customClasses='slides-fullscreen-button' onClick={onFullscreenHandler}>
              <img src={FullscreenIcon} alt='Full screen icon'/>
              Fullscreen
            </TransparentButton>
          )}
          <span className="presenter-slide-description__title">{currentSlide?.title}</span>
          <span className="slide-count">
            <PrevArrowIcon
              onClick={onPrevSlideHandler}
              className={`${arrowsClasses.prev} ${prevArrowDisabledClass}`}
            />
            Slide
            <span className="slide-count__current-slide">
              {currentSlideIndex + additionalIndex}
            </span> of
            <span className="slide-count__number-of-slides">
              {numberOfSlides}
            </span>
            <NextArrowIcon
              onClick={onNextSlideHandler}
              className={`${arrowsClasses.next} ${nextArrowDisabledClass}`}
            />
          </span>
        </div>
        <hr/>
      </div>
      <div ref={descriptionBoxRef} className="presenter-slide-description__description-wrapper custom-scrollbar">{currentSlide?.speakerNotes}</div>
    </div>
  );
};

export default observer(PresenterSlideDescription);
